module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }